import { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";
import { Outlet, useLocation } from "react-router";
import { Slide, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import BackToTop from "./partials/backToTop";
import {AppDispatch, RootState} from "../core/redux/store";
import { getUserProfile } from "../core/redux/userSlice";
import Footer from "./partials/footer";
import Header from "./partials/header";
import { utils } from "../core/helpers/utils";
import {useNavigate} from "react-router-dom";

const Layout = () => {
  const location = useLocation();
  const dispatch = useDispatch<AppDispatch>();
  const passwordToken = utils.getPasswordToken();
  const {user} = useSelector((state: RootState) => state.user);
  const navigate = useNavigate()

  useEffect(() => {
    if (passwordToken) {
      dispatch(getUserProfile());
    }
  }, [passwordToken, dispatch]);

  useEffect(() => {
    if (!(!!utils.getPasswordToken() && !!user)) {
      navigate("/login");
      return;
    }
  }, [user, navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <>
      <div className="main-wrapper">
        <div>
          <Header />
          <Outlet />
          <Footer />
          <BackToTop />
        </div>

        <div className="sidebar-overlay"></div>
      </div>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        limit={5}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
        transition={Slide}
      />
    </>
  );
};

export default Layout;
